import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ms_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (path) =>
  path ? `${API}/files/${path}?auth=${localStorage.getItem("ms_token")}` : "";

// Backend list endpoints now return {items, total}. This keeps the frontend resilient
// to both the old plain-array shape and the new paginated shape.
export const asItems = (res) => (Array.isArray(res.data) ? res.data : res.data.items || []);
export const asTotal = (res) => (Array.isArray(res.data) ? res.data.length : res.data.total ?? res.data.items?.length ?? 0);

export async function uploadFile(file, endpoint = "/upload") {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(endpoint, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export default api;
